import mergeClasses from '../../../utils/shallowMerge';
import defaultClasses from './Accordion.module.scss';
import { useAccordionContext } from './useAccordionContext';
import React, {
  Children,
  cloneElement,
  isValidElement,
  useCallback,
} from 'react';

export const AccordionSection = (props) => {
  const {
    children,
    id = '0',
    backgroundColor,
    customClasses = null,
    ...rest
  } = props;
  const styles = mergeClasses(defaultClasses, customClasses);
  const { handleSectionToggle, openSectionIds } = useAccordionContext();
  const handleSectionToggleWithId = useCallback(
    () => handleSectionToggle(id),
    [handleSectionToggle, id],
  );

  const isSectionOpen = openSectionIds.has(id);

  const childrenWithProps = Children.map(children, (child) => {
    // Checking isValidElement is the safe way and avoids a TS error too.
    if (isValidElement(child)) {
      return cloneElement(child, {
        handleSectionToggleWithId,
        id,
        isSectionOpen,
      });
    }
    return child;
  });

  // eslint-disable-next-line no-unused-vars
  const { isOpen, ...cleanRest } = rest;
  return (
    <div
      className={styles.section}
      style={{
        '--accordion-background-color': backgroundColor && backgroundColor,
      }}
      {...cleanRest}
    >
      {childrenWithProps}
    </div>
  );
};